import { chain } from 'lodash';
import APIClient from './APIClient';
import { fileDownload } from './fileUtils';
import { setMessageExportUnavailable } from '../components/Alert/actions';

export const exportFile = (endpoint, payload, sorting, filename = 'exported', dispatch) => {
  const params = {
    params: {
      sort_by: sorting.id,
      sort_order: sorting.desc ? 'DESC' : 'ASC',
    },
  };

  return APIClient.post(endpoint, payload, params)
    .then(({ data, headers }) => {
      fileDownload(data, `${filename}.csv`, headers['content-type']);
    })
    .catch((err) => {
      if (err.response && err.response.status === 500) {
        dispatch(setMessageExportUnavailable());
      }
      console.error(err);
    });
};

export const getExportPayload = (filter, selectAll, items, uuids_key = 'uuids') => {
  const payloadFilter = chain(filter)
    .keyBy('id')
    .mapValues('value')
    .value();
  const payload = {
    filter_by: { ...payloadFilter },
  };

  payload.filter_by[uuids_key] = selectAll ? [] : items;

  return payload;
};
